var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('r-modal-container', {
    attrs: {
      "dialog": false,
      "title": null,
      "headerPaddingBottom": 16
    }
  }, [_c('r-row', {
    attrs: {
      "gapHidden": "",
      "wrap": true
    }
  }, [_c('r-col', {
    attrs: {
      "cols": _vm.buildRPoint(6)
    }
  }, [_c('div', {
    staticClass: "mx-15"
  }, [_c('div', {
    staticClass: "camembert harakiri--text mb-4"
  }, [_vm._v(" Мобильное приложение ")]), _c('div', {
    staticClass: "parmigiano troy--text mb-12"
  }, [_vm._v(" Чтобы скачать мобильное приложение «Цифровое ресурсоснабжение», наведите камеру смартфона на QR-код или воспользуйтесь ссылкой ниже ")]), _c('r-button-link', {
    staticClass: "mb-15",
    attrs: {
      "title": _vm.linkDownloadApp,
      "color": "alien",
      "size": "salamis"
    },
    on: {
      "click": _vm.toDownloadLink
    }
  }), _c('div', {
    staticClass: "pa-9 white--bg geban"
  }, [_c('div', {
    attrs: {
      "id": "qrDownloadApp"
    }
  })])], 1)]), _c('r-col', {
    attrs: {
      "cols": _vm.buildRPoint(6)
    }
  }, [_c('div', {
    staticClass: "mx-15"
  }, [_c('div', {
    staticClass: "camembert harakiri--text mb-4"
  }, [_vm._v(" Настройка конфигурации мобильного приложения ")]), _c('div', {
    staticClass: "mb-8"
  }, [_c('div', {
    staticClass: "parmigiano troy--text mb-1"
  }, [_vm._v(" 1. Откройте мобильное приложение «Цифровое ресурсоснабжение»; ")]), _c('div', {
    staticClass: "parmigiano troy--text mb-1"
  }, [_vm._v(" 2. На экране настройки сервера нажмите «Сканировать QR-код»; ")]), _c('div', {
    staticClass: "parmigiano troy--text mb-1"
  }, [_vm._v(" 3. Наведите камеру на QR-код ниже. ")])]), _c('div', {
    staticClass: "pa-9 white--bg geban"
  }, [_c('div', {
    attrs: {
      "id": "qrSettings"
    }
  })])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }